import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  Button,
  Grid2,
  Card,
  CardContent,
  CardMedia,
  Box,
} from "@mui/material";
import { styled } from "@mui/system";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Footer from "./Footer";
import Navbar from "./Navbar"; // Import the Navbar component
// import OurServices from "./OurServices";
import OurServicesNew from "./OurServicesNew";
import Hero from "./Hero";
import AppPreview from "./AppPreview";
// import RiskStep from "./RiskStep";
import AppFeatures from "./AppFeatures";
// import Products from "./Products";
import WhyUs from "./whyUs";
// import ExploreMF from "./ExploreMF";
// import MFBenefits from "./MFBenefits";
import HorizontalScroll from "./HorizontalScroll";
import Features from "./Features";
import { Helmet } from 'react-helmet-async';
import ITRScreen from "./ITR";

// import SplashScreen from "./SplashScreen";


// ... existing imports ...



function HomePage() {
  const navigate = useNavigate();

  const handleApplyNow = () => {
    navigate("/banking-products");
  };

  const commingSoon = () => {
    navigate("/coming-soon");
  };


  return (
    <>

      <Helmet>
        <title>
          ArthGyan | Mutual Funds, SIP, Credit Score & Wealth Management
        </title>

        <meta
          name="description"
          content="Invest in mutual funds, start SIPs, check your credit score, and manage your finances smartly with ArthGyan."
        />

        <meta
          name="keywords"
          content="ArthGyan, mutual funds, SIP investment, credit score, CIBIL, wealth management, finance app, investment platform"
        />

        <meta name="author" content="ArthGyan" />

        <meta
          property="og:title"
          content="ArthGyan | Smart Investment & Wealth Management"
        />

        <meta
          property="og:description"
          content="Start SIPs, invest in mutual funds, track credit score, and grow your wealth with ArthGyan."
        />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="ArthGyan" />
      </Helmet>
      <Navbar />
      <Hero />
      <AppFeatures />
      <WhyUs />
      <ITRScreen />
      {/* <OurServicesNew /> */}
      <Features />
      <AppPreview />
      <Footer />
    </>
  );
}

export default HomePage;
